// extracted by mini-css-extract-plugin
export default {"check":"g0GnHI","japan":"BuFmp_","minus":"EKTNlE"};